import React, { useState, useEffect } from "react";
import { removeFromQueue } from "../store/guestsStore";
import { MessageOutlined, EditOutlined } from "@ant-design/icons";
import "./GuestCard.css";
import { useUnit } from "effector-react";
import { $queue, updateGuest } from "../store/guestsStore";
import { moveToSeated } from "../store/guestsStore";

const API_URL =
  "https://uvjwfdf5aa.execute-api.eu-west-1.amazonaws.com/test/guest-ranking-system";

const GuestCard = ({ guest }) => {
  const [showComments, setShowComments] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showTablePopup, setShowTablePopup] = useState(false);

  // Inside GuestCard component:
  const queue = useUnit($queue); // Get the latest guest list
  const guestFromStore = queue.find((g) => g.id === guest.id);
  const guestData = guestFromStore || guest; // Always use the latest data

  const [tableNumber, setTableNumber] = useState("");
  const [hookahTypes, setHookahTypes] = useState([]);
  const [message, setMessage] = useState("");
  const [forceRender, setForceRender] = useState(0);

  // Fetch Hookah Types from API
  useEffect(() => {
    fetch(
      "https://uvjwfdf5aa.execute-api.eu-west-1.amazonaws.com/test/setup-configuration-api",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          place_id: "shka17c8h3",
          action: "read",
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setHookahTypes(data?.data?.hookah_types || []);
      })
      .catch((error) =>
        console.error("❌ Error fetching hookah types:", error)
      );
  }, []);

  // Close pop-up when clicking outside
  const closePopup = (e) => {
    if (e.target.classList.contains("popup-overlay")) {
      setShowEditPopup(false);
      setShowComments(false);
    }
  };
  const [formData, setFormData] = useState({
    user_mobile: guest.mobile || "",
    user_date_of_birth: guest.birthday || "",
    user_hookah_preferences: guest.likes || [],
    user_hookah_dislikes: guest.dislikes || [],
    user_hookah_chill: true,
    user_hookah_strength_range: guest.strength
      ? guest.strength.split("-").map(Number)
      : [3, 5], // Default 3-5
    user_hookah_types: guest.types || [],
    user_name: guest.name ? guest.name.split(" ")[0] : "",
    user_surname: guest.name ? guest.name.split(" ")[1] : "",
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle array inputs (hookah preferences, dislikes, types)
  const handleArrayChange = (field, value) => {
    if (!Array.isArray(value)) return;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Handle API call
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure valid strength range
    const strengthRange = tobaccoStrengthRange
      .map((n) => (isNaN(n) ? 3 : n))
      .join("-");

    const updatedGuest = {
      user_id: guest.id,
      user_mobile: formData.user_mobile || "",
      user_date_of_birth: formData.user_date_of_birth || "",
      user_hookah_preferences: formData.user_hookah_preferences || [],
      user_hookah_dislikes: formData.user_hookah_dislikes || [],
      user_hookah_strength_range: strengthRange, // 🔹 Ensure valid numbers
      user_hookah_types: formData.user_hookah_types || [],
      user_name: formData.user_name || "",
      user_surname: formData.user_surname || "",
    };

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "change", data: updatedGuest }),
      });

      const result = await response.json();
      if (result.statusCode === 200) {
        setMessage("✅ Данные успешно обновлены!");
        updateGuest(updatedGuest); // ✅ Update UI Immediately!

        console.log("✅ Called updateGuest with:", updatedGuest);
        setForceRender((prev) => prev + 1); // 🔄 Force React to rerender

        console.log("✅ Guest updated, forcing rerender");
        setTimeout(() => setShowEditPopup(false), 1500);
      } else {
        setMessage("❌ Ошибка при обновлении!");
      }
    } catch (error) {
      setMessage("❌ Ошибка сети!");
    }
  };

  const assignTable = () => {
    if (tableNumber) {
      console.log("📩 Assigning guest to table:", tableNumber, guest);
      moveToSeated({ ...guest, tableNumber });
      removeFromQueue(guest.id); // Remove from new guests
      setShowTablePopup(false);
    } else {
      console.warn("⚠️ No table number entered!");
    }
  };
  const handleKeyPress = (key) => {
    if (key === "⌫") {
      setTableNumber(tableNumber.slice(0, -1)); // Delete last digit
    } else if (key === "Назначить") {
      assignTable();
    } else {
      setTableNumber((prev) => (prev.length < 3 ? prev + key : prev)); // Max 3 digits
    }
  };

  const [tobaccoStrengthRange, setTobaccoStrengthRange] = useState(
    guest.strength ? guest.strength.split("-").map(Number) : [3, 5] // Default: [3,5] if guest.strength is missing
  );

  // Update the min/max range
  const handleStrengthChange = (index, value) => {
    let newRange = [...tobaccoStrengthRange];

    // Ensure value is a number, fallback to 1 if NaN
    const numValue = Number(value) || 1;

    newRange[index] = numValue;

    // Prevent invalid ranges (min cannot be greater than max)
    if (newRange[0] > newRange[1]) newRange[index] = newRange[1];

    setTobaccoStrengthRange(newRange);
  };

  useEffect(() => {
    console.log(`📌 Guest ${guest.id} added at: `, new Date(guest.timestamp));
  }, [guest]);

  useEffect(() => {
    console.log("🚀 Guest data updated:", guestData);
  }, [guestData]);

  return (
    <>
      <div className="guest-card">
        {/* Close Button */}
        <button
          className="guest-card-close"
          onClick={() => removeFromQueue(guest.id)}
        >
          ✕
        </button>

        {/* Photo & Rating */}
        <div className="guest-photo-container">
          <img src={guest.photo} alt={guest.name} className="guest-photo" />
          <span className="guest-rating">⭐ {guest.rating}</span>
        </div>

        {/* Name */}
        <h3 className="guest-name">{guest.name}</h3>

        {/* Likes */}
        {guest.likes.length > 0 && (
          <p className="guest-likes">{guest.likes.join(", ")}</p>
        )}

        {/* Dislikes */}
        {guest.dislikes.length > 0 && (
          <p className="guest-dislikes">{guest.dislikes.join(", ")}</p>
        )}

        {/* Hookah Types */}
        {guest.types.length > 0 && (
          <p className="guest-types">{guest.types.join(", ")}</p>
        )}

        {/* Strength, Comments & Edit Buttons */}
        <div className="guest-actions">
          <div className="guest-tag">🪥 {guest.strength}</div>
          <button
            className="guest-button"
            onClick={() => setShowComments(true)}
          >
            <MessageOutlined />
          </button>
          <button
            className="guest-button"
            onClick={(e) => {
              e.stopPropagation(); // Prevents accidental multiple triggers
              setShowEditPopup(true);
            }}
          >
            <EditOutlined />
          </button>
        </div>

        {/* Set Table & Skip Buttons */}
        <div className="guest-buttons">
          <button
            className="set-table-btn"
            onClick={() => setShowTablePopup(true)}
          >
            Назначить стол
          </button>

          <button
            className="skip-btn"
            onClick={() => removeFromQueue(guest.id)}
          >
            Пропустить
          </button>
        </div>

        {/* Comments Pop-up */}
        {showComments && (
          <div className="popup-overlay" onClick={closePopup}>
            <div className="popup">
              <h3>Комментарии</h3>
              <ul>
                {Array.isArray(guest.reviews) && guest.reviews.length > 0 ? (
                  guest.reviews.map((review, index) => (
                    <li key={index}>{review}</li>
                  ))
                ) : (
                  <p>Нет комментариев</p>
                )}
              </ul>
              <button onClick={() => setShowComments(false)}>Закрыть</button>
            </div>
          </div>
        )}
      </div>
      {/* Edit Pop-up */}
      {/* Edit Pop-up */}
      {showEditPopup && (
        <div className="popup-overlay" onClick={() => setShowEditPopup(false)}>
          <div
            className="popup edit-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Редактировать гостя</h3>
            <button
              className="popup-close"
              onClick={() => setShowEditPopup(false)}
            >
              ✕
            </button>

            <form onSubmit={handleSubmit}>
              <input type="hidden" name="user_id" value={guest.id} />

              <label>Имя</label>
              <input
                type="text"
                name="user_name"
                value={formData.user_name}
                onChange={handleChange}
              />

              <label>Фамилия</label>
              <input
                type="text"
                name="user_surname"
                value={formData.user_surname}
                onChange={handleChange}
              />

              <label>Номер телефона</label>
              <input
                type="text"
                name="user_mobile"
                value={formData.user_mobile}
                onChange={handleChange}
              />

              <label>Дата рождения</label>
              <input
                type="date"
                name="user_date_of_birth"
                value={formData.user_date_of_birth}
                onChange={handleChange}
              />

              <label>Крепость табака (1-10)</label>
              <div className="strength-range">
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={
                    tobaccoStrengthRange[0] !== undefined
                      ? tobaccoStrengthRange[0]
                      : 1
                  } // Prevents undefined
                  onChange={(e) => handleStrengthChange(0, e.target.value)}
                />
                <span>—</span>
                <input
                  type="number"
                  min="1"
                  max="10"
                  value={
                    tobaccoStrengthRange[1] !== undefined
                      ? tobaccoStrengthRange[1]
                      : 1
                  } // Prevents undefined
                  onChange={(e) => handleStrengthChange(1, e.target.value)}
                />
              </div>

              <label>Типы табака</label>
              <div className="hookah-type-selection">
                {hookahTypes.map((type) => (
                  <button
                    key={type}
                    className={`hookah-type ${
                      formData.user_hookah_types.includes(type)
                        ? "selected"
                        : ""
                    }`}
                    onClick={() =>
                      handleArrayChange("user_hookah_types", [
                        ...formData.user_hookah_types,
                        type,
                      ])
                    }
                  >
                    {type}
                  </button>
                ))}
              </div>

              <button type="submit" className="submit-btn">
                Сохранить
              </button>
            </form>

            {/* Notification */}
            {message && <p className="message">{message}</p>}
          </div>
        </div>
      )}
      {showTablePopup && (
        <div className="popup-overlay" onClick={() => setShowTablePopup(false)}>
          <div
            className="popup calculator-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Назначить стол</h3>
            <button
              className="popup-close"
              onClick={() => setShowTablePopup(false)}
            >
              ✕
            </button>

            <div className="table-display">{tableNumber || "0"}</div>

            <div className="table-keypad">
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, "⌫", 0, "Назначить"].map((key) => (
                <button
                  key={key}
                  className={`key ${key === "Назначить" ? "confirm" : ""}`}
                  onClick={() => handleKeyPress(key)}
                >
                  {key}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GuestCard;
